module.exports = __webpack_public_path__ + "img/taco-bell.07f42bf3.png";